import React from "react";

export type AsProps<E extends React.ElementType> = {
  as?: E;
} & React.ComponentProps<E>;

function Replacement<E extends React.ElementType = "div">({
  as: As = "div" as E,
  ...props
}: AsProps<E>): React.ReactElement | null {
  return <As {...props} />;
}

export { Replacement };
